// The file contents for the current environment will overwrite these during build.
// The build system defaults to the prod environment which uses `environment.prod.ts`, but if you do
// `npm run build-dev` or `ng run rms-ui:build --configuration=dev` then this file will be used instead.

export const environment = {
  production: false,
  slowResponseAlertMs: 120000
};
